// ABOUTME: Helpers to turn a widget depthRange config into the "min,max" search filter value.
// ABOUTME: Depth is relative to the hierarchy root (0 = root node), max omitted = unbounded.

// Node lists start at depth 1 so the hierarchy root node is not listed.
export const DEFAULT_NODE_LIST_DEPTH_RANGE = [1];

export function parseDepthRange(value: unknown): number[] | undefined {
    if (!Array.isArray(value)) return undefined;
    const range = value.filter((v): v is number => typeof v === 'number' && Number.isFinite(v));
    return range.length > 0 ? range : undefined;
}

// Converts a [min] / [min, max] depth range into the search "min,max" filter value
// (max omitted = unbounded). Returns undefined when no range is configured.
export function depthFilterValue(depthRange?: number[]): string | undefined {
    if (!depthRange || depthRange.length === 0) return undefined;
    const min = depthRange[0];
    const max = depthRange.length > 1 ? depthRange[1] : undefined;
    return `${min},${max ?? ''}`;
}

// Depth filter value of a node list widget config, falling back to the default range
// that skips the root node. Returns a string so callers can use it as a stable
// memo dependency.
export function resolveNodeListDepthValue(
    config?: { depthRange?: unknown } | null,
): string | undefined {
    const depthRange = parseDepthRange(config?.depthRange) ?? DEFAULT_NODE_LIST_DEPTH_RANGE;
    return depthFilterValue(depthRange);
}
